import React from 'react'

const LogoIcon = ({ className = "h-6 w-6", stroke = "currentColor" }) => (
  <svg 
    xmlns="http://www.w3.org/2000/svg" 
    viewBox="0 0 24 24" 
    fill="none" 
    stroke={stroke} 
    strokeWidth="2" 
    strokeLinecap="round" 
    strokeLinejoin="round" 
    className={className}
  >
    <path d="M3 7V5c0-1.1.9-2 2-2h2"></path>
    <path d="M17 3h2c1.1 0 2 .9 2 2v2"></path>
    <path d="M21 17v2c0 1.1-.9 2-2 2h-2"></path>
    <path d="M7 21H5c-1.1 0-2-.9-2-2v-2"></path>
    <rect width="7" height="7" x="7" y="7" rx="1"></rect>
    <rect width="7" height="7" x="10" y="10" rx="1"></rect>
  </svg>
)

export default LogoIcon 